import React from 'react';


class Header extends React.Component {
  render() {
    return (
      <div className='infa-header'>
        <div className='infa-logo'></div>
      </div>
    );
  }

  handleClick = (e) => {
    this.props.onSkip();
  }
}

export default Header;
